import type { FC } from 'react';
import React from 'react';

import type { TFormHiddenInput } from './models';

export const FormHiddenInput: FC<TFormHiddenInput> = ({
    Field,
    Input,
    defaultValue = '',
    name = '',
    value = '',
}) => (
    <Field
        initialValue={value}
        name={name}
        render={({ input }) => (
            <Input name={input.name} type="hidden" value={input.value || defaultValue} />
        )}
    />
);
